import { render, staticRenderFns } from "./bcTable.vue?vue&type=template&id=b046d30e&scoped=true"
import script from "./bcTable.vue?vue&type=script&lang=js"
export * from "./bcTable.vue?vue&type=script&lang=js"
import style0 from "./bcTable.vue?vue&type=style&index=0&id=b046d30e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b046d30e",
  null
  
)

export default component.exports